<template>
  <div class="slider-title">
    {{ title }}
    <div class="close-panel"><slot /></div>
    <div v-if="!hideCloseButton" class="close-panel" @click="closePanel"><i class="fal fa-times close-icon"></i></div>
  </div>
</template>
<script>

export default {
  props: {
    title: String,
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closePanel: function () {
      this.$parent.$emit('closePanel')
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.$parent.$emit('emitSave')
    })
    this.$on('closePanel', () => {
      this.$parent.$emit('closePanel')
    })
  }
}
</script>
<style scoped>
/* .close-panel {
  display: flex;
} */
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalLayoutTop.vue